<template>
  <div class="page-container">
    <div class="class-form-head">协议上传管理</div>
    <div class="head">
      <BaseInfo :detail-info="detailInfo"></BaseInfo>
      <Button
        v-if="portOrg == 0"
        type="primary"
        class="log-btn"
        @click="handleViewLog"
      >操作日志</Button>
    </div>
    <RemarkCard style="margin-bottom: 14px">
      <h2 style="margin-bottom: 6px">提示：</h2>
      <p style="margin-bottom: 6px">
        ①PDF版协议内容，需预先获取协议文件，然后在下载后的协议文件中进行【盖章】、【上传】操作。
      </p>
      <p style="margin-bottom: 6px">
        ②原始文件请<span class="color-red">联系</span><strong>平台对应负责人</strong>获取！
      </p>
    </RemarkCard>
    <h1 class="class-form-head" style="margin-bottom: 16px">附件上传状态</h1>
    <ul class="list">
      <li
        v-for="(item, index) in fileInfoList"
        :key="item.type"
        class="item"
        :class="{ active: item.fileId }"
      >
        <div class="poin" :class="[`poin` + (index + 1)]">
          {{ index + 1 }}
        </div>
        <h2>
          <span class="color-red">{{ item.name }}</span>上传盖章扫描件（彩版）
        </h2>
        <div class="pdf-content">
          <div v-if="!item.fileId" class="none-file">
            <span style="margin-right: 12px">暂无任何文件</span><Button
              v-if="showActionBtn(item.type)"
              type="primary"
              size="small"
              @click="handleUpload(item.type)"
            >上传</Button>
          </div>
          <div v-else class="upload-info">
            <div class="left" @click="handleViewPdf(item)">
              <img src="./components/image/pdf.png">
            </div>
            <div class="right">
              <p class="fileName" style="margin-bottom: 10px">
                <span style="margin-right: 10px">{{ item.fileName }}</span>
                <Icon
                  v-if="showActionBtn(item.type)"
                  class="cursor-pointer"
                  type="md-close-circle"
                  @click="handleDelect(item)"
                ></Icon>
              </p>
              <div>
                <Button
                  type="primary"
                  size="small"
                  style="margin-right: 12px"
                  @click="handleViewPdf(item)"
                >预览</Button><Button
                  type="primary"
                  size="small"
                  @click="handleDownload(item)"
                >下载</Button>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <div v-if="portOrg == 0">
      <h1 class="class-form-head" style="margin-bottom: 16px">配置状态</h1>
      <ul class="list">
        <li class="item" :class="{ active: finalFileId }">
          <div class="poin">4</div>
          <h2>上传已配置的编辑域文件（彩板）</h2>
          <div class="pdf-content">
            <div v-if="!finalFileId" class="none-file">
              <span style="margin-right: 12px">暂无任何文件</span><Button
                v-if="showActionBtn(8)"
                type="primary"
                size="small"
                @click="handleUpload(8)"
              >上传</Button>
            </div>
            <div v-else class="upload-info">
              <div class="left" @click="handleViewFinalFilePdf(finalFileId)">
                <img src="./components/image/pdf.png">
              </div>
              <div class="right">
                <p
                  v-if="showActionBtn(8)"
                  class="fileName"
                  style="margin-bottom: 10px"
                >
                  <span style="margin-right: 10px">{{ finalFileName }}</span>
                  <Icon
                    class="cursor-pointer"
                    type="md-close-circle"
                    @click="handleDelectFinalFile(item)"
                  ></Icon>
                </p>
                <div>
                  <Button
                    type="primary"
                    size="small"
                    style="margin-right: 12px"
                    @click="handleViewFinalFilePdf(finalFileId)"
                  >预览</Button><Button
                    type="primary"
                    size="small"
                    @click="handleDownload({fileId:finalFileId,fileName:finalFileName})"
                  >下载</Button>
                </div>
              </div>
            </div>
          </div>
        </li>
        <li class="item" :class="{ active: configSts == 1 }">
          <div class="poin">5</div>
          <h2>文件编辑域配置状态</h2>
          <Form :label-width="180">
            <FormItem label="文件编辑域配置状态:">
              <Select
                v-model="configSts"
                placeholder="请选择"
                style="width: 100px"
              >
                <Option value="1">已完成</Option>
                <Option value="0">待配置</Option>
              </Select>
              <Button
                v-if="showActionBtn(8)"
                type="primary"
                style="margin-left: 12px"
                @click="handleCfm"
              >
                保存</Button>
              <p class="color-gray">
                提示：需完成配置，才可正式生成用户的签约协议模板。仅上传配置域文件无法生效。
              </p>
            </FormItem>
          </Form>
        </li>
      </ul>
    </div>
    <UploadModal
      ref="uploadModalRef"
      :org-file-id="orgFileId"
      :plat-file-id="platFileId"
      :school-file-id="schoolFileId"
      :agreement-id="agreementId"
      @on-success="onUploadSuccess"
    ></UploadModal>
    <ViewPdf ref="viewPdf" :is-from-cdn="true"></ViewPdf>
    <RecModal ref="recModalRef" :has-download="true" :is-file-name="true" :code-type-map="codeTypeMap"></RecModal>
  </div>
</template>

<script>
import BaseInfo from './components/BaseInfo.vue';
import platformApi from '@/request/eduCenter/platform.js';
import RemarkCard from '@c/Base/RemarkCard.vue';
import UploadModal from './components/UploadModal.vue';
import RecModal from '@c/RecModal.vue';
import { mapMutations } from 'vuex';
import ViewPdf from '@c/Base/ViewPdf';
import cateringAdmin from '@/request/cateringAdmin/index.js';
import commonApi from '@/request/common/index.js';
import axios from 'axios';
export default {
  components: {
    BaseInfo,
    RemarkCard,
    UploadModal,
    ViewPdf,
    RecModal
  },
  data() {
    return {
      agreementId: this.$route.query.agreementId,
      detailInfo: null,
      fileInfo: [{
        type: '1',
        name: '机构',
        fileId: '',
        fileName: ''
      }, {
        type: '2',
        name: '平台',
        fileId: '',
        fileName: ''
      }, {
        type: '3',
        name: '学校',
        fileId: '',
        fileName: ''
      }],
      finalFileId: '',
      finalFileName: '',
      orgFileId: '',
      platFileId: '',
      schoolFileId: '',
      configSts: '',
      downloadUrl: '',
      downloadToken: '',
      portOrg: Number(localStorage.getItem('portOrg')),
      codeTypeMap: {
        'SERVICE_TEMPLATE_OPERATE@UPLOAD': '附件上传',
        'SERVICE_TEMPLATE_OPERATE@DELETE': '附件删除',
        'SERVICE_TEMPLATE_OPERATE@SET_TEXT_PDF_STATUS': '文件编辑域配置状态'
      }
    };
  },
  computed: {
    fileInfoList() {
      const typeMap = {
        0: this.fileInfo[1],
        2: this.fileInfo[2],
        3: this.fileInfo[0]
      };

      return this.portOrg == 3 ? [typeMap[this.portOrg]] : [typeMap[3], typeMap[0], typeMap[2]];
    }
  },
  created() {
    this.getTemplateDetail();
  },
  methods: {
    ...mapMutations([
      'CLOSE_BROWSINGHISTORYLIST'
    ]),
    showActionBtn(type) {
      switch (Number(type)) {
        case 1:
          return [3, 0].includes(this.portOrg);
          break;
        case 2:
          return this.portOrg == 0;
          break;
        case 3:
          return [2, 0].includes(this.portOrg);
          break;
        case 8:
          return this.portOrg == 0;
          break;
      }
    },
    handleGoBack() {
      this.CLOSE_BROWSINGHISTORYLIST(this.$route.name);
      this.$router.push({
        name: 'eduCenter_platform_agreementManage'
      });
    },
    onUploadSuccess() {
      this.getTemplateDetail();
    },
    handleDelect(row) {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确定删除？</p>',
        onOk: async() => {
          const typeMap = {
            1: 4,
            2: 6,
            3: 1
          };
          this.$Spin.show();
          platformApi.deleteFileIdRelOrg({
            agreementId: this.agreementId,
            orgType: typeMap[Number(row.type)]
          }).then(res => {
            this.$Spin.hide();
            if (res.status == 200) {
              this.$Message.success('删除成功');
              this.getTemplateDetail();
            }
          }).catch(err => {
            this.$Spin.hide();
          });
        },
        onCancel: () => {

        }
      });
    },
    handleDelectFinalFile() {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确定删除？</p>',
        onOk: async() => {
          this.$Spin.show();
          platformApi.deleteFinalFile({
            agreementId: this.agreementId

          }).then(res => {
            this.$Spin.hide();
            if (res.status == 200) {
              this.$Message.success('删除成功');
              this.getTemplateDetail();
            }
          });
        },
        onCancel: () => {

        }
      });
    },
    handleUpload(type) {
      this.$refs.uploadModalRef.handleShow(type);
    },
    handleViewPdf(row) {
      this.$refs.viewPdf.handleShow(row.fileId);
    },
    handleViewFinalFilePdf(fileId) {
      this.$refs.viewPdf.handleShow(fileId);
    },
    // 获取详情
    async getTemplateDetail() {
      this.$Spin.show();
      const res = await platformApi.getServiceAgreementTemplateDetail({
        agreementId: this.agreementId
      });
      this.$Spin.hide();
      if (res.status == 200) {
        this.detailInfo = res.message;
        this.schoolFileId = res.message.schoolFileId;
        this.platFileId = res.message.platFileId;
        this.orgFileId = res.message.orgFileId;
        const filesNameObj = res.message.remark ? JSON.parse(res.message.remark) : {
          orgFileName: '', platFileName: '', schoolFileName: '', finalFileName: ''
        };
        this.fileInfo.forEach(item => {
          if (item.type == 1) {
            item.fileId = this.detailInfo.orgFileId;
            item.fileName = filesNameObj.orgFileName ? filesNameObj.orgFileName : '文件名称.pdf';
          }
          if (item.type == 2) {
            item.fileId = this.detailInfo.platFileId;
            item.fileName = filesNameObj.platFileName ? filesNameObj.platFileName : '文件名称.pdf';
          }
          if (item.type == 3) {
            item.fileId = this.detailInfo.schoolFileId;
            item.fileName = filesNameObj.schoolFileName ? filesNameObj.schoolFileName : '文件名称.pdf';
          }
        });
        this.finalFileId = this.detailInfo.finalFileId;
        this.finalFileName = filesNameObj.finalFileName ? filesNameObj.finalFileName : '文件名称.pdf';
        this.configSts = String(this.detailInfo.configSts);

        //        this.getFileName(this.detailInfo.finalFileId)

        // setTimeout(async () => {
        //   let res1 = await commonApi.getPreviewToken({
        //     fileId: this.detailInfo.platFileId
        //   });
        //   console.log('------------', this.detailInfo.platFileId)
        //   console.log(new URL(`${res1.message.previewUrl}?fileId=${this.detailInfo.platFileId}&token=${res1.message.token}`))
        // }, 1000)
      }
    },
    // 下载token
    async getDownloadtoken(fileId) {
      return new Promise(async(resolve, reject) => {
        const params = {
          fileId: [fileId]
          // type: 2
          // fileId
        };
        const res = await platformApi.getDownServiceTemplatePdfApi(params);
        if (res.status === 200) {
          this.downloadUrl = res.message.downUrl;
          this.downloadToken = res.message.token;
        }
        resolve();
      });
    },
    async handleDownload({ fileId, fileName }) {
      await this.getDownloadtoken(fileId);
      // return;
      const href = `${this.downloadUrl}?fileId=${fileId}`;
      const downloadElement = document.createElement('a');
      downloadElement.style.display = 'none';
      downloadElement.href = href;
      downloadElement.download = fileName; // 下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); // 点击下载
      document.body.removeChild(downloadElement); // 下载完成移除元素
    },

    async getFileName(fileId, target) {
      return new Promise(async(resolve, reject) => {
        await this.getDownloadtoken(fileId);
        const href = `${this.downloadUrl}?fileId=${fileId}&token=${this.downloadToken}`;
        axios.get(href, {
          responseType: 'blob'
        }).then(response => {
          console.log(response);
          console.log('responseresponseresponseresponseresponse');
          // const url = window.URL.createObjectURL(new Blob([response.data]));
          // const link = document.createElement('a');
          // let fname = `${this.schoolName}-${this.month}学校考勤确认单导入模板.xlsx`;
          // link.href = url;
          // link.setAttribute('download', fname);
          // document.body.appendChild(link);
          // link.click();
        }).catch(error => {
          console.log('error', error);
          console.log('error:' + JSON.stringify(error));
        });
      });
    },
    //
    async handleCfm() {
      if (this.configSts == 1) {
        if (!this.orgFileId) {
          this.$Message.warning('机构盖章扫描件还未上传～');
          return false;
        }
        if (!this.platFileId) {
          this.$Message.warning('平台盖章扫描件还未上传～');
          return false;
        }
        if (!this.schoolFileId) {
          this.$Message.warning('学校盖章扫描件还未上传～');
          return false;
        }
        if (!this.finalFileId) {
          this.$Message.warning('已配置的编辑域文件还未上传～');
          return false;
        }
      }
      const res = await platformApi.updateConfigSts({
        agreementId: this.agreementId,
        configSts: this.configSts
      });
      if (res.status == 200) {
        this.$Message.success('保存成功');
        this.handleGoBack();
      }
    },
    handleViewLog() {
      this.$refs.recModalRef.handleShow({
        recType: 'SERVICE_TEMPLATE_OPERATE@',
        objectId: this.agreementId
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.page-container {
  background-color: #fff;
  width: 100%;
  height: 100%;
  padding: 20px 20px 100px;
  .head {
    position: relative;
    min-height: 100px;
    .log-btn {
      position: absolute;
      right: 60px;
      top: 4px;
    }
  }
}
.class-form-head {
  background: rgba(0, 0, 0, 0.05);
  padding: 16px;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
  padding-left: 24px;
}

.list {
  .active {
    .poin {
      background-color: #488ffa;
      border: 1px solid #488ffa;
      color: #fff;
      &:before {
        background-color: #488ffa !important;
      }
    }
  }
  .item {
    padding-left: 60px;
    margin-bottom: 22px;
    position: relative;
    .poin {
      width: 24px;
      height: 24px;
      border-radius: 100% 100%;
      border: 1px solid #eee;
      display: flex;
      justify-content: center;
      align-items: center;
      position: absolute;
      left: 12px;
      top: -6px;
    }
    .poin1,
    .poin2 {
      &:before {
        content: '';
        display: inline-block;
        width: 1px;
        background-color: #eee;
        height: 106px;
        position: absolute;
        top: 22px;
      }
    }
    h2 {
      margin-bottom: 12px;
    }
    .pdf-content {
      border: 1px solid #eee;
      border-radius: 4px;
      height: 80px;
      .none-file {
        padding-top: 30px;
        padding-left: 100px;
      }
      .upload-info {
        display: flex;
        .left {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 80px;
          height: 80px;
          img {
            width: 48px;
            height: 48px;
          }
        }
        .right {
          padding-top: 10px;
          flex: 1;
          .fileName {
            display: flex;
            justify-content: space-between;
            width: 99%;
            background-color: #ebf8fe;
            padding: 4px 10px;
          }
        }
      }
    }
  }
}
</style>
